/**
 * Fired on `document` when the PDP swaps to a sibling colourway.
 *
 * Colours are modelled as separate Shopify products stitched together by the
 * `global.metafield_product_handle` metafield, and the swap happens entirely
 * client-side (see `onColorChange` in sections/pdp-section.js). Anything
 * rendered from the page-load product — recommendation sliders in particular —
 * has to listen for this to stay in sync.
 *
 * detail: { handle: string, id: number }
 */
export const PRODUCT_CHANGED_EVENT = 'pdp:product-changed';
